import React from 'react';
import {AppText, AppErrorText} from './Typography';

interface AppCheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
}

const AppCheckbox: React.FC<AppCheckboxProps> = ({label, error, className = '', ...props}) => (
  <div className="flex items-center gap-2 w-full">
    <input type="checkbox" className={`accent-primary rounded border bg-white border-gray-200 focus:border-gray-500 transition-all outline-none ${error ? 'border-red-500' : ''} ${className}`} {...props} />
    {label && <AppText className="font-bold">{label}</AppText>}
    {error && <AppErrorText className="text-sm mt-1">{error}</AppErrorText>}
  </div>
);

export default AppCheckbox;
